import React, { createContext, useState, useEffect, useContext } from "react";

// Create a context for theme management
export const ThemeContext = createContext();

// Custom hook to use the theme context
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

// Theme provider component
export const ThemeProvider = ({ children }) => {
  // Check if user has previously set a theme preference in localStorage
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme ? savedTheme : "light"; // Default to light theme
  };

  // State to track current theme
  const [theme, setTheme] = useState(getInitialTheme);

  // Toggle between light and dark themes with buttery smooth transition
  const toggleTheme = () => {
    document.documentElement.classList.add("theme-transition");
    setTheme((prevTheme) => {
      const newTheme = prevTheme === "light" ? "dark" : "light";
      localStorage.setItem("theme", newTheme); // Save preference to localStorage
      return newTheme;
    });
    window.setTimeout(() => {
      document.documentElement.classList.remove("theme-transition");
    }, 450);
  };

  // Apply theme to document when it changes
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
